import React, { useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import dexie from '../offlineDB';
import { syncTuneRecordings } from '../utils/syncTuneRecordings';

const TuneRecorder = ({ tune, user, onUpdateRecordings, onRecordingSaved }) => {
  const [recording, setRecording] = useState(false);
  const [label, setLabel] = useState('');
  const recorderRef = useRef(null);
  const streamRef = useRef(null);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
        ? 'audio/webm;codecs=opus'
        : 'audio/webm';

      const recorder = new MediaRecorder(stream, { mimeType });
      const chunks = [];

      recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          chunks.push(e.data);
        }
      };

      recorder.onstop = async () => {
        const blob = new Blob(chunks, { type: mimeType });
        console.log('🎤 Blob size:', blob.size);

        if (blob.size === 0) {
          alert("Recording failed — no audio was captured.");
          return;
        }

        const id = uuidv4();
        const createdAt = new Date().toISOString();

        const tempUrl = URL.createObjectURL(blob);
        const audio = new Audio(tempUrl);

        audio.onloadedmetadata = async () => {
          const duration = Math.round(audio.duration);

          const newRecording = {
            id,
            label,
            url: null,
            duration,
            createdAt,
            storagePath: null,
            localBlob: blob
          };

          const updatedRecordings = [...(tune.recordings || []), newRecording];

          await dexie.tunes.update(tune.id, { recordings: updatedRecordings });

          if (onUpdateRecordings) {
            onUpdateRecordings(updatedRecordings);
          }

          await syncTuneRecordings({ ...tune, recordings: updatedRecordings }, user);

          if (onRecordingSaved) {
            onRecordingSaved(newRecording);
          }

          setLabel('');
        };
      };

      recorderRef.current = recorder;
      recorder.start();
      setRecording(true);
    } catch (err) {
      console.error("🎤 Failed to start recording:", err);
      alert("Microphone not available or permission denied.");
    }
  };

  const stopRecording = () => {
    const recorder = recorderRef.current;
    if (recorder && recorder.state === 'recording') {
      recorder.stop();
      streamRef.current?.getTracks().forEach(track => track.stop());
      setRecording(false);
    }
  };

  return (
    <div style={{ marginTop: '1rem', textAlign: 'center' }}>
      <input
        type="text"
        placeholder="Recording label"
        value={label}
        onChange={e => setLabel(e.target.value)}
        disabled={recording}
        style={{
          padding: '6px',
          marginRight: '8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          width: '200px'
        }}
      />
      {!recording ? (
        <button onClick={startRecording} className="big-button">🎙 Start Recording</button>
      ) : (
        <button
          onClick={stopRecording}
          className="big-button"
          style={{ backgroundColor: '#e00', color: '#fff' }}
        >
          ⏹ Stop
        </button>
      )}
    </div>
  );
};

export default TuneRecorder;
